import type { SectionConfig } from '../lib/types';

export const customerSection: SectionConfig = {
  id: 'customers.cus', entity: 'customer', title: 'Customers',
  softDelete: false,
  defaultSort: { column: 'created', direction: 'desc' },
  columns: [
    { key: 'email', title: 'Email', sortable: true },
    { key: 'name', title: 'Name', sortable: true },
    { key: 'phone', title: 'Phone' },
    { key: 'lastLogin', title: 'Last Login', type: 'date', sortable: true },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
  formFields: [
    { key: 'email', title: 'Email', type: 'text', required: true },
    { key: 'name', title: 'Name', type: 'text' },
    { key: 'phone', title: 'Phone', type: 'text' },
    { key: 'statusId', title: 'Status', type: 'select', relation: { entity: 'customerStatus', labelField: 'title' } },
    { key: 'lastLogin', title: 'Last Login', type: 'text', readOnly: true },
    { key: 'enabled', title: 'Enabled', type: 'boolean' },
  ],
};

export const customerStatusSection: SectionConfig = {
  id: 'customers.cst', entity: 'customerStatus', title: 'Customer Statuses',
  softDelete: false,
  defaultSort: { column: 'id', direction: 'asc' },
  columns: [
    { key: 'title', title: 'Title', sortable: true },
    { key: 'params', title: 'Params' },
  ],
  formFields: [
    { key: 'title', title: 'Title', type: 'text', required: true },
    { key: 'params', title: 'Params (key=value,key2=value2)', type: 'text' },
  ],
};

export const countrySection: SectionConfig = {
  id: 'customers.cou', entity: 'country', title: 'Countries',
  softDelete: false,
  defaultSort: { column: 'name', direction: 'asc' },
  columns: [
    { key: 'code', title: 'ISO Code', sortable: true },
    { key: 'name', title: 'Name', sortable: true },
    { key: 'codeAlt', title: 'VAT Prefix' },
    { key: 'eu', title: 'EU', type: 'boolean' },
  ],
  formFields: [
    { key: 'code', title: 'ISO Code (2-char)', type: 'text', required: true },
    { key: 'name', title: 'Name', type: 'text', required: true },
    { key: 'codeAlt', title: 'Alt Code (VAT Prefix)', type: 'text' },
    { key: 'eu', title: 'EU Member', type: 'boolean' },
  ],
};

export const downloadLogSection: SectionConfig = {
  id: 'customers.dlo', entity: 'downloadLog', title: 'Download Log',
  readOnly: true,
  defaultSort: { column: 'date', direction: 'desc' },
  columns: [
    { key: 'date', title: 'Date', type: 'date', sortable: true },
    { key: 'ip', title: 'IP Address' },
    { key: 'path', title: 'Path' },
    { key: 'filename', title: 'Filename' },
    { key: 'customerId', title: 'Customer ID', type: 'number' },
  ],
  formFields: [],
};
